<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Attendance
    </div>
    <div class="card-body" style="overflow: auto; height: 460px;">
        <div class="row p-1" style="margin-top: -20px;" *ngIf="this.InputData.EmpType.toLowerCase() === 'front'">
            <div class="col-md-5 px-1">
                <label class="Label">Client</label>
                <ng-select name="client" [items]="ClientLoad" bindLabel="ClientGroupName"
                    bindValue="ClientGroupMasterID" [(ngModel)]="ClientId" placeholder="Select Client"
                    (change)="MyTeams('SiteMaster', this.InputData.ProfileID, '');ondropdownChange('ClientMaster');">
                </ng-select>
            </div>
            <div class="col-md-5 px-1">
                <label class="Label">Site</label>
                <ng-select name="site" [items]="SiteLoad" bindLabel="SiteName" bindValue="SiteMasterID"
                    [(ngModel)]="SiteId" placeholder="Select Site" (change)="onChange()">
                </ng-select>
            </div>
        </div>
        <div class="row p-1">
            <div class="col-md-2 p-1">
                <select class="form-select" aria-label="dateSelect" placeholder="" title="dateselect" name="DateSelect"
                    [(ngModel)]="Filter.DateType" required (change)="onChange()">
                    <option value="Today">Today</option>
                    <option value="Yesterday">Yesterday</option>
                    <option value="Monthly">Monthly</option>
                    <option value="Date">Date</option>
                    <option value="DateRange">Date Range</option>
                </select>
            </div>
            <div class="col-md-3 p-1" *ngIf="Filter.DateType=='DateRange' || Filter.DateType == 'Date'">
                <div class="input-group">
                    <input class="form-control" placeholder="From Date" name="FromDateObj"
                        [(ngModel)]="Filter.FromDateObj" ngbDatepicker #FromDateObj="ngbDatepicker" required readonly />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                        type="button"></button>
                </div>
                <div class="invalid-feedback">
                    Please select from date!
                </div>
            </div>
            <div class="col-md-3 p-1" *ngIf="Filter.DateType=='DateRange'">
                <div class="input-group">
                    <input class="form-control" placeholder="To Date" name="ToDateObj" [(ngModel)]="Filter.ToDateObj"
                        ngbDatepicker #ToDateObj="ngbDatepicker" required readonly />
                    <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                        type="button"></button>
                </div>
                <div class="invalid-feedback">
                    Please select to date!
                </div>
            </div>
            <div class="col-md-3 p-1" *ngIf="Filter.DateType=='Monthly'">
                <ngb-datepicker #dp [(ngModel)]="Filter.selectedMonth" class="month-year"
                    (navigate)="Filter.selectedMonth= $event.next;onNavigate()" name="dateselect"
                    style="width: 100%;"></ngb-datepicker>
            </div>
            <div class="col-md-2 p-1">
                <button class="btn btn-sm btn-primary" name="cancel"
                    (click)="this.MyTeams('SummaryCount', this.InputData.ProfileID,'');this.MyTeams('SummaryList', this.InputData.ProfileID,'');">
                    <i class="bi bi-download" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Load':'Loading...'}}
                </button>
            </div>
        </div>
        <div class="row p-1 d-flex flex-wrap justify-content-between mt-0" style=" margin-top: -30px;">
            <div class="col-auto p-1 cursor-pointer" *ngFor="let element of SumarryCount; let i = index">
                <div class="card text-center p-2 shadow" style="width: 130px;border: 1px solid lightgray;"
                    (click)="onCardClick(element)" [class.selected]="element.isSelect">
                    <p class="form-label" [style.color]="convertColorToHex(element['Color'])">
                        {{ element['Count'] }}
                    </p>
                    <div class="form-label" style="font-size: 12px; margin-top: -10px;">
                        {{ element['Type'] }}
                    </div>
                </div>
            </div>
        </div>
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th scope="col" style="width: 5px;">#</th>
                    <th>Employee</th>
                    <th>In Time</th>
                    <th>Out Time</th>
                    <!-- <th>Attendance Remark</th> -->
                    <th scope="col" style="width : 5px;">Attendance</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of SumarryList; let i = index">
                    <th scope="row" style="width: 5px;">{{i+1}}</th>
                    <td>
                        <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="element['Photo'] != null && element['Photo'] != ''" mat-card-image
                                    class="userImage" [src]="element['Photo']" />
                                <div *ngIf="element['Photo'] == null || element['Photo'] == ''" class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(element['FullName'])}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label">{{element['FullName']}}</span><br />
                                <span class="text-label-light">#{{element['EmpCode']}}</span><br />
                                <span class="text-label-light">{{element['DesignationName']}}</span><br>
                                <span class="text-label-light">
                                    {{element['AttendanceDate'] | date : 'dd MMM yyyy'}}</span>
                            </div>
                        </div>
                    </td>
                    <td style="align-items: center;" style="align-items: center;width: 300px;">
                        <div class="row no-gutters cursor-pointer" style="align-items: center;">
                            <div class="col-2" style="align-items: center;">
                                <img *ngIf="element['DailyAttendancePhoto'] != null && element['DailyAttendancePhoto'] != ''"
                                    mat-card-image class="userImage" [src]="element['DailyAttendancePhoto']" />
                                <div *ngIf="element['DailyAttendancePhoto'] == null || element['DailyAttendancePhoto'] == ''"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(element['FullName'])}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label-light">{{element['InTime'] | date: 'dd MMM yyyy'}}</span><br>
                                <span class="text-label-light">{{element['InTime'] | date: 'HH:mm:ss'}}</span>
                            </div>
                        </div>
                    </td>
                    <td style="align-items: center;" style="align-items: center;width: 300px;">
                        <div class="row no-gutters cursor-pointer" style="align-items: center;">
                            <div class="col-2" style="align-items: center;">
                                <img *ngIf="element['DailyAttendancePhotoOut'] != null && element['DailyAttendancePhotoOut'] != ''"
                                    mat-card-image class="userImage" [src]="element['DailyAttendancePhotoOut']" />
                                <div *ngIf="element['DailyAttendancePhotoOut'] == null || element['DailyAttendancePhotoOut'] == ''"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(element['FullName'])}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label-light">{{element['Outime'] | date: 'dd MMM yyyy'}}</span><br>
                                <span class="text-label-light">{{element['Outime'] | date: 'HH:mm:ss'}}</span>
                            </div>
                        </div>
                    </td>
                    <!-- <td scope="row" style="width : 5px;">
                        <div [style.background-color]="convertColorToHex(element['Color'])"
                            style="color: #ffffff; padding: 4px 8px; border-radius: 4px; display: inline-block;">
                            {{element['AttendanceRemark']}}</div>
                    </td> -->
                    <td scope="row" style="width : 5px;">
                        <div [style.background-color]="convertColorToHex(element['Color'])"
                            style="color: #ffffff; padding: 4px 8px; border-radius: 4px; display: inline-block;">
                            {{element['AttendanceRemark']}}</div>
                        <button class="btn btn-sm" name="att{{i}}" (click)="AttendanceView(element)">
                            <img *ngIf="!isDisabled" src="../../../assets/AttendanceCal.png" alt="Attendance"
                                style="height: 25px; width: 25px;" />
                            <span class="spinne r-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                        </button>

                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-outline-primary" name="cancel" (click)="Close()">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>